import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "guestFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isGuest = this.selectTarget.value === "guest_booking"
    this.guestFieldsTarget.style.display = isGuest ? "block" : "none"
  }
}
